import axios from 'axios';
const base = 'motivoing';

function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}

function getById(id) {
    return axios.get([base, id].join('/'));
}

function update(data) {
    return axios.put([base, data.id_g].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const MotivoIngService = {
    getAll,
    register,
    getById,
    update,
    destroy
};
export default MotivoIngService;